module.exports = __webpack_public_path__ + "static/mapdesktop-5e6ab12326cec2d3ee17a9ba91a5f565.png";